module.exports = __webpack_public_path__ + "static/media/asc-vial.dd419155.svg";